
var styles = [
  'webkitTransform',
  'MozTransform',
  'msTransform',
  'OTransform',
  'transform'
];

var el = document.createElement('p');
var style;

for (var i = 0; i < styles.length; i++) {
  style = styles[i];
  if (null != el.style[style]) {
    module.exports = style;
    break;
  }
}



/*****************
 ** WEBPACK FOOTER
 ** ./~/transform-property/index.js
 ** module id = 18
 ** module chunks = 0
 **/